import React from "react";
import {
  calculateInvoiceDiscountAmount,
  formatInvoiceDiscountLabel,
  isValidCustomDiscountAmount,
} from "../../utilis/invoiceDiscountHelpers";
import { formatInvoiceMoney } from "../../utilis/invoiceLineItemHelpers";

function InvoiceLineItemDiscountSection({
  lineLabel = "Line item",
  discountTab = "predefined",
  onDiscountTabChange,
  discountRules = [],
  selectedRuleId = "",
  onSelectedRuleIdChange,
  customAmount = "",
  onCustomAmountChange,
  reason = "",
  onReasonChange,
  lineGross = 0,
  appliedAmount = 0,
  error = "",
  editMode = false,
  isDiscountUpdate = false,
  onUpdateDiscount = null,
  onCancel = null,
  updatingDiscount = false,
}) {
  const previewAmount = calculateInvoiceDiscountAmount({
    tab: discountTab,
    ruleId: selectedRuleId,
    rules: discountRules,
    customAmount,
    grossSubtotal: lineGross,
    maxTotal: lineGross,
  });
  const displayAmount = appliedAmount > 0 ? appliedAmount : previewAmount;

  return (
    <tr className="invoice-line-item-discount-row">
      <td colSpan={9}>
        <div className="invoice-line-item-discount">
          <span className="invoice-line-item-discount__label">Discount</span>
          <div
            className="invoice-line-discount__tabs invoice-line-item-discount__tabs"
            role="tablist"
            aria-label={`${lineLabel} discount type`}
          >
            <button
              type="button"
              role="tab"
              aria-selected={discountTab === "predefined"}
              className={`invoice-line-discount__tab${
                discountTab === "predefined" ? " is-active" : ""
              }`}
              onClick={() => onDiscountTabChange?.("predefined")}
            >
              Percentage
            </button>
            <button
              type="button"
              role="tab"
              aria-selected={discountTab === "custom"}
              className={`invoice-line-discount__tab${
                discountTab === "custom" ? " is-active" : ""
              }`}
              onClick={() => onDiscountTabChange?.("custom")}
            >
              Custom
            </button>
          </div>

          <div className="invoice-line-item-discount__amount">
            {discountTab === "predefined" ? (
              <select
                className="invoice-xero-lines-table__select invoice-line-item-discount__select"
                value={selectedRuleId}
                onChange={(event) =>
                  onSelectedRuleIdChange?.(event.target.value)
                }
              >
                <option value="">Choose rule…</option>
                {discountRules.map((rule) => (
                  <option key={rule.id} value={rule.id}>
                    {formatInvoiceDiscountLabel(rule)}
                  </option>
                ))}
              </select>
            ) : (
              <input
                type="number"
                min="0"
                step="0.01"
                className="invoice-xero-lines-table__input invoice-xero-lines-table__input--num invoice-line-item-discount__custom"
                placeholder="0.00"
                value={customAmount}
                onChange={(event) => onCustomAmountChange?.(event.target.value)}
              />
            )}
          </div>

          <div className="invoice-line-item-discount__reason">
            <input
              type="text"
              className="invoice-xero-lines-table__input invoice-line-item-discount__reason-input"
              placeholder="Reason for discount"
              value={reason}
              onChange={(event) => onReasonChange?.(event.target.value)}
            />
          </div>

          {displayAmount > 0 ? (
            <span className="invoice-line-item-discount__applied">
              -
              {formatInvoiceMoney(displayAmount, "", {})}
            </span>
          ) : null}

          {editMode ? (
            <div className="invoice-line-item-discount__actions">
              {onCancel ? (
                <button
                  type="button"
                  className="btn btn-sm btn-outline-secondary invoice-line-item-discount__cancel-btn"
                  onClick={() => onCancel?.()}
                  disabled={updatingDiscount}
                >
                  Cancel
                </button>
              ) : null}
              <button
                type="button"
                className="btn btn-sm btn-primary invoice-line-item-discount__update-btn"
                onClick={() => onUpdateDiscount?.()}
                disabled={updatingDiscount}
              >
                {updatingDiscount
                  ? "Updating…"
                  : isDiscountUpdate
                    ? "Update discount"
                    : "Apply discount"}
              </button>
            </div>
          ) : null}
        </div>

        {error ? (
          <div className="invoice-line-item-discount__error">{error}</div>
        ) : null}
      </td>
    </tr>
  );
}

export default InvoiceLineItemDiscountSection;
